import { useQuery } from 'react-query'
import { axios } from '../../../lib'

type CheckCnpjCpfResponse = {
  message: string
  sellerName?: string
}

const checkCnpjCpf = (cnpjCpf: string): Promise<CheckCnpjCpfResponse> => {
  return axios.get('/customers/check-cnpj-cpf', {
    params: {
      cnpjCpf
    }
  })
}

export function useCheckCnpjCpf(cnpjCpf: string, enabled = false) {
  return useQuery(['checkCnpjCpf', cnpjCpf], () => checkCnpjCpf(cnpjCpf), {
    enabled: enabled && !!cnpjCpf && cnpjCpf.replace(/\D/g, '').length >= 11,
    retry: false,
    refetchOnWindowFocus: false
  })
}
